import { TripActivityStatus } from "@cnx/common";
import {
  InfoItemReceiver,
  InfoItemSender,
} from "components/InfoItem/InfoItemAddress";
import InfoItemCargo from "components/InfoItem/InfoItemCargo";
import InfoItemProduct from "components/InfoItem/InfoItemProduct";
import React from "react";
import CombinedReference from "./CombinedReference";

export type TripActivityDetailsInfo = {
  id: string;
  terminalStopId: string;
  status: TripActivityStatus | null;
  beginAddress: string | null;
  endAddress: string | null;
  sender: string | null;
  receiver: string | null;
  loadingMeter: number | null;
  unitAmount: number | null;
  unitCode: string | null;
  productDescription: string | null;
  product: string | null;
  temperatureSetPoint: number | null;
  combinedReference: string | null;
};

interface TerminalActivityDetailsSimpleProps {
  terminalActivity: TripActivityDetailsInfo;
}

const TerminalActivityDetailsSimple: React.FC<
  TerminalActivityDetailsSimpleProps
> = ({ terminalActivity }) => {
  return (
    <>
      <InfoItemSender
        address={terminalActivity.beginAddress}
        name={terminalActivity.sender}
      />
      <InfoItemReceiver
        address={terminalActivity.endAddress}
        name={terminalActivity.receiver}
      />
      <InfoItemCargo
        loadingMeter={terminalActivity.loadingMeter ?? 0}
        unitAmount={terminalActivity.unitAmount ?? 0}
        unitCode={terminalActivity.unitCode ?? ""}
      />
      <InfoItemProduct
        productDescription={terminalActivity.productDescription}
        product={terminalActivity.product}
        temperatureSetPoint={terminalActivity.temperatureSetPoint}
        disabled={terminalActivity.status === TripActivityStatus.DONE}
      />
      <CombinedReference reference={terminalActivity.combinedReference} />
    </>
  );
};

export default TerminalActivityDetailsSimple;
